var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 1.88005L7.98 0.380049C8.62 1.43338 9.24667 2.36672 9.86 3.18005C10.4733 3.99338 11.1067 4.72005 11.76 5.36005C12.4267 6.00005 13.1333 6.59338 13.88 7.14005V7.26005C13.1333 7.79338 12.4267 8.38672 11.76 9.04005C11.1067 9.68005 10.4733 10.4067 9.86 11.22C9.24667 12.02 8.62 12.9467 7.98 14L5.9 12.52C6.46 11.6534 7.04 10.9 7.64 10.26C8.24 9.60672 8.84 9.04672 9.44 8.58005C10.04 8.11338 10.6267 7.74005 11.2 7.46005C11.7733 7.18005 12.3133 6.98005 12.82 6.86005V7.54005C12.3133 7.42005 11.7733 7.22005 11.2 6.94005C10.6267 6.64672 10.04 6.26672 9.44 5.80005C8.84 5.33338 8.24 4.78005 7.64 4.14005C7.04 3.48672 6.46 2.73338 5.9 1.88005ZM0.56 5.82005H6.14C7.14 5.82005 8.06667 5.86672 8.92 5.96005C9.77333 6.05338 10.5533 6.17338 11.26 6.32005L12.76 7.20005L11.26 8.06005C10.5533 8.20672 9.77333 8.32672 8.92 8.42005C8.06667 8.51338 7.14 8.56005 6.14 8.56005H0.56V5.82005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.b4f809adf549fe8886ebd087d9154b1f.svg";
export { ForwardRef as ReactComponent };